// Indirizzi scritti a mano, senza Google Maps [sc-48762].
// Spec: docs/superpowers/specs/2026-09-21-sc-48762-indirizzo-libero-design.md

/**
 * Ricerca su Google Maps a partire dal testo, senza chiave API.
 * Serve al PDF generato in creazione, prima che l'API restituisca il `link`.
 */
export function linkMaps(address) {
  const testo = (address || "").trim();
  if (!testo) return "";
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    testo
  )}`;
}

/** L'indirizzo è compilato? Unica regola rimasta dopo la rimozione di Maps. */
export function indirizzoValido(address) {
  return typeof address === "string" && address.trim().length > 0;
}

/** Testo del link a Maps nel PDF: dice cosa fa, al posto dell'URL troncato [sc-48860]. */
export const TESTO_LINK_MAPPA = "Apri su Google Maps";
